{
  "name": "chill.workflow-app.ui",
  "version": "3.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --output-hashing=all",
    "build:dev": "ng build --configuration=development --output-hashing=all",
    "build:uat": "ng build --configuration=staging --output-hashing=all",
    "build:preprod": "ng build --configuration=preprod  --output-hashing=all",
    "watch": "ng build --watch --configuration development  --output-hashing=all",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "~21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@azure/msal-angular": "^5.3.1",
    "@azure/msal-browser": "^5.16.0",
    "@microsoft/signalr": "^9.0.6",
    "@primeuix/themes": "^2.0.3",
    "ng2-pdf-viewer": "^10.4.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.9",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.18",
    "@angular/cli": "~21.2.18",
    "@angular/compiler-cli": "^21.2.17",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.24",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "rxjs": "^7.8.2",
    "typescript": "~5.9.3"
  }
}